"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkQualitySDK = void 0;
var clientId_1 = require("./util/clientId");
var NetworkQualitySDK = /** @class */ (function () {
    function NetworkQualitySDK() {
    }
    /**
     * @returns Persistent unique identifier of the client
     */
    NetworkQualitySDK.prototype.clientId = function () {
        return (0, clientId_1.clientId)();
    };
    return NetworkQualitySDK;
}());
exports.NetworkQualitySDK = NetworkQualitySDK;
//# sourceMappingURL=networkQuality.js.map